import React, { useContext } from "react";
import { filtrationcontext } from "../../context/Filtercontext";
import TableRow from "../Helpers/Table/TableRow";
import { formatDate } from "../../JsHelpers/DateFormat";
import Empty from "../Helpers/Empty/Empty";
import trans from "../../utils";
import { SpeedUnit } from "../../JsHelpers/PlatformUnits";
import { useSelector } from "react-redux";

export default function EventsTableBody({ data }) {
  let { searchQuery } = useContext(filtrationcontext);
  const inf = useSelector((state) => state.users.user);
  let SearchFilteredData = data;
  if (searchQuery) {
    SearchFilteredData = data?.filter((i) =>
      i.type.toLowerCase().includes(searchQuery?.toLowerCase())
    );
  }
  function knotsToKmPerHour(knots) {
    return knots * 1.852;
  }
  if (SearchFilteredData?.length === 0)
    return (
      <Empty
        title={trans("No notifications found")}
        subtitle={trans("Filter to get your notifications")}
      />
    );
  return (
    <>
      {SearchFilteredData?.map((i) => {
        let { formattedDate, formattedTime } = formatDate(i.eventTime);
        return (
          <div key={i.id} className="table-row">
            <TableRow
              value={i.type}
              // eslint-disable-next-line react/style-prop-object
              style="table-element-name ps-0 text-capitalize"
            />

            <TableRow value={formattedDate + " " + formattedTime} />
            <TableRow
              value={
                i.attributes.speed
                  ? SpeedUnit(i.attributes.speed,inf.attributes.speedUnit || "kn") 
                  : "- - - - -"
              }
            />
          </div>
        );
      })}
    </>
  );
}
